<mat-card>
  <mat-card-title-group class="px-3 pt-3">
    <mat-card-title>{{customer.name}}</mat-card-title>
    <mat-card-subtitle>CVR: {{customer.reg_no}}</mat-card-subtitle>
    <div fxLayoutAlign="end">
      <button mat-mini-fab color="primary" (click)="editCustomer()"><mat-icon>edit</mat-icon></button>
    </div>
  </mat-card-title-group>
  <mat-card-content>
    <div fxFill="row" fxLayoutGap="10px">
      <div fxFlex="33">
        @if (customer.care_of) {
          <p>{{customer.care_of}}</p>
        }
        <p>
          {{customer.street}}<br/>
          {{customer.zip}} {{customer.city}}<br/>
          {{`country.${customer.country}` | translate}}
        </p>
        <p>
          <span class="mat-body-2">{{customer.contact}}</span><br/>
          <a class="plain" [href]="'mailto:' + customer.email" matTooltip="Skriv e-mail til {{customer.email}}}">{{customer.email}}</a><br/>
          <a class="plain" [href]="'tel:' + customer.phone" matTooltip="Ring til {{customer.phone}}">{{customer.phone}}</a>
        </p>
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div fxFlex="33">
        <dl>
          <dt>Sprog i board:</dt>
          <dd><b>{{customer.settings.board?.languages?.join(', ')}}</b></dd>

          <dt>Ansøgersprog:</dt>
          <dd><b>{{customer.settings.languages}}</b></dd>

          <dt>Tidszone:</dt>
          <dd><b>{{customer.settings.time_zone}}</b></dd>
        </dl>
      </div>
      <mat-divider [vertical]="true"></mat-divider>
      <div fxFlex="30">
        <p>
          <span class="mat-body-2">Kunde tag: </span><br/>
          <b>{{customer.settings?.tag}}</b>
        </p>
      </div>
    </div>
  </mat-card-content>
</mat-card>
@if (!isActivated) {
  <mat-card class="mt-3">
    <mat-card-title-group>
      <mat-card-title>Prøvetilstand!</mat-card-title>
    </mat-card-title-group>
    <mat-card-content>
      <p>Fonden har ikke aktiveret GrantOne.<p>
        <p>Når GrantOne aktiveres slettes alle data fra prøveperioden, dvs. alle ansøgninger, møder, bevillinger, udbetalinger etc.</p>
        <p>Det er derfor vigtigt, at GrantOne aktiveres inden fonden begynder at modtage og behandle ansøgninger.</p>
      </mat-card-content>
      <mat-card-actions>
        <div fxLayout fxLayoutAlign="flex-end center">
          <button
            mat-flat-button
            color="primary"
            (click)="doActivate()"
            ><mat-icon>verified</mat-icon> Aktiver!</button>
          </div>
        </mat-card-actions>
      </mat-card>
    }
    <mat-divider class="my-3"></mat-divider>
    <div class="statistics my-3" fxLayout="row" fxLayoutGap="1em" fxLayoutAlign="space-between center">
      <app-customer-stats
        fxFlex="25"
        [subdomain]="customer.subdomain"
        [type]="UsageStatistics.Projects"
      ></app-customer-stats>
      <app-customer-stats
        fxFlex="25"
        [subdomain]="customer.subdomain"
        [type]="UsageStatistics.Applied"
      ></app-customer-stats>
      <app-customer-stats
        fxFlex="25"
        [subdomain]="customer.subdomain"
        [type]="UsageStatistics.Granted"
      ></app-customer-stats>
      <app-customer-stats
        fxFlex="25"
        [subdomain]="customer.subdomain"
        [type]="UsageStatistics.Paid"
      ></app-customer-stats>
    </div>
    <div class="statistics" fxLayout="row" fxLayoutGap="1em" fxLayoutAlign="space-between center">
      <app-customer-stats
        fxFlex="25"
        [subdomain]="customer.subdomain"
        [type]="UsageStatistics.Profiles"
      ></app-customer-stats>
      <app-customer-stats
        fxFlex="25"
        [subdomain]="customer.subdomain"
        [type]="UsageStatistics.Messages"
      ></app-customer-stats>
      <app-customer-stats
        fxFlex="25"
        [subdomain]="customer.subdomain"
        [type]="UsageStatistics.Attachments"
      ></app-customer-stats>
      <app-customer-stats
        fxFlex="25"
        [subdomain]="customer.subdomain"
        [type]="UsageStatistics.Assets"
      ></app-customer-stats>
    </div>
    <mat-divider class="my-3"></mat-divider>
    <mat-card>
      <mat-card-header class="mb-2">
        <mat-card-title>Kategorier</mat-card-title>
      </mat-card-header>
      <mat-card-content class="categories">
        @for (category of categories; track category) {
          <mat-card>
            <mat-card-content class="category">
              <div fxLayout="row" fxLayoutGap="2em" fxLayoutAlign="start baseline">
                <div class="category-initials mt-2" [ngStyle]="{'background-color': category?.color}" [colorContrast]="category.color">
                  <b>{{category?.initials}}</b>
                </div>
                <h3 class="m-0">{{category?.name}}</h3>
                @if (category.journal_no_pattern !== customer.settings.journal_no?.pattern) {
                  <span
                    matTooltip="Kategorispecifikt journalnummerformat"
                  class="ml-1">*</span>
                }
              </div>
              <button mat-icon-button (click)="editCategory(category)">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-card-content>
          </mat-card>
        }
      </mat-card-content>
    </mat-card>
    <mat-divider class="my-3"></mat-divider>
